<template>
  <div class="mx-4">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div :class="result">
      <div class="row">
        <div class="col-12 pb-0" style="display: flex; justify-content: center">
          <h4 class="mb-0">Solicitudes de cambio de horario</h4>
        </div>
        <div class="col-12 pt-0" style="display: flex; justify-content: flex-end">
          <v-btn color="primary" elevation="1" @click="Consultar">Consultar</v-btn>
        </div>
        <div class="col-12 mt-3">
          <v-card>
            <v-card-title style="display: flex; justify-content: flex-end">
              <v-col cols="12">
                <v-row style="display: flex; align-items: flex-end">
                  <v-col cols="4" class="pa-1">
                    <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                          class="pr-2 pb-1"
                        ></v-text-field>
                      </template>
                      <v-date-picker :title-date-format="titleDateFormat" v-model="begin" range locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialogBegin.save(begin)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.mu_supervisor_evaluacion"
                      label="MU"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      v-model="send.idfirmarse_sistema"
                      label="Agente"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-autocomplete
                      hide-details
                      v-model="send.nomestatus"
                      :items="filter.nomestatus"
                      label="Estatus"
                      solo
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="8" class="pa-1">
                <v-btn elevation="2" @click="cleanFilter">Limpiar</v-btn>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
              </v-col>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              class="elevation-1"
              hide-default-footer
              loading-text="Cargando usuarios... Porfavor espere"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <div class="pa-1">
                  <button
                    v-on:click.prevent="Mostrar_Detalle_Solicitud(item.idsolicitudmodificarhorario)"
                    class="btn teleperformance-purpura2 view-details"
                  >
                    Ver detalle
                  </button>
                </div>
              </template>
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
            <PaginationFooter
              @sendItemsPerPage="getItemsPerPage"
              @lastClic="lastClic"
              @nextClic="nextClic"
              :page="page"
              :itemsLength="itemsLength"
            />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment-timezone";
import GeneralMixin from "@/components/mixins/General";
import { mapActions } from "vuex";
import PaginationFooter from "@/components/General/PaginationFooter";
import axios from "axios"; // Importar Axios en el componente

export default {
  mixins: [GeneralMixin],
  components: {
    PaginationFooter,
  },
  data: function () {
    return {
      url: process.env.VUE_APP_URL,
      headers: [
        { text: "ID de la solicitud", align: "center", value: "idsolicitudmodificarhorario" },
        { text: "MU", align: "start", value: "mu_supervisor_evaluacion" },
        { text: "Nombre de Agente", align: "left", value: "nomagente_sistema" },
        { text: "CCMS", align: "left", value: "idfirmarse_sistema" },
        { text: "Fecha Solicitado", align: "start", sortable: false, value: "fecha_creacion" },
        { text: "Estatus", align: "left", value: "nomestatus" },
        { text: "Motivo de rechazo", align: "left", value: "motivo_de_rechazo" },
        { text: "Acciones", align: "center", value: "actions" },
      ],
      items: [],
      itemsBackup: [],
      filter: {
        nomestatus: [
          "Pendiente de Autorizar",
          "No Autorizado",
          "Autorizado",
          "En Proceso por Servidor",
          "Procesado por Servidor",
          "Error al procesar",
        ],
      },
      send: {
        mu_supervisor_evaluacion: "",
        idfirmarse_sistema: "",
        nomestatus: "",
        motivo: "",
      },
      begin: [],
      modalBegin: false,
      search: "",
      loading: "",
      result: "",
      solicitudes: [],
      maxPages: 1000,
      begin: [],
      data: {
        skip: 1,
        take: 10,
        filters: { fechas: this.begin },
      },
      page: 1,
      itemsPerPage: 10,
      itemsLength: 0,
    };
  },
  methods: {
    ...mapActions("horarios", ["setComponent"]),
    getItemsPerPage(dato) {
      this.itemsPerPage = parseInt(dato);
      this.page = 1;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.mu_supervisor_evaluacion ? this.send.mu_supervisor_evaluacion : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    lastClic() {
      this.page--;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.mu_supervisor_evaluacion ? this.send.mu_supervisor_evaluacion : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    nextClic() {
      this.page++;
      this.data = {
        skip: this.page,
        take: this.itemsPerPage,
        filters: {
          fechas: this.begin,
          mu: this.send.mu_supervisor_evaluacion ? this.send.mu_supervisor_evaluacion : undefined,
          agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
          status: this.send.nomestatus ? this.send.nomestatus : undefined,
        },
      };
      this.Consultar();
    },
    async Consultar() {
      this.Cargando();
      try {
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");
        if (this.begin.length < 2) {
          this.begin[1] = this.begin[0];
        }
        const url = this.url + "v2/api/admin/filter/solicitudes";
        let data = (this.data = {
          skip: this.page,
          take: this.itemsPerPage,
          filters: {
            fechas: this.begin,
            mu: this.send.mu_supervisor_evaluacion ? this.send.mu_supervisor_evaluacion : undefined,
            agente: this.send.idfirmarse_sistema ? this.send.idfirmarse_sistema : undefined,
            status: this.send.nomestatus ? this.send.nomestatus : undefined,
          },
        });
        const {
          data: { data: items, count },
        } = await axios.post(url, { data });
        this.items = items.map((obj) => {
          return {
            ...obj,
            fecha_creacion: moment(obj.fecha_creacion).utc().format("DD-MM-YYYY HH:mm"),
          };
        });
        this.itemsLength = count;
        this.itemsBackup = this.items;

        if (items != null) {
          this.solicitudes = items;
        }
        if (this.solicitudes.length === 0) {
          swal("No hay solicitudes", "Por el momento no hay solicitudes", "info");
        }
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
      }
    },
    Mostrar_Detalle_Solicitud(item) {
      this.setComponent({ component: "detail", item: item });
    },
    Mostrar_Result() {
      this.loading = "d-none";
      this.result = "";
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    cleanFilter() {
      for (let key in this.send) {
        this.send[key] = "";
      }
      this.Consultar();
    },
  },
  mounted() {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    this.begin = [sevenDaysAgo.toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
    this.Consultar();
  },
  computed: {
    dateRangeText() {
      return this.begin.join(" ~ ");
    },
    titleDateFormat() {
      // Aquí puedes incluir la clase personalizada en la cadena de formato de fecha
      return (date) => {
        return this.$vuetify.lang.t("Fechas seleccionadas");
      };
    },
  },
};
</script>
<style></style>
